var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('mobileTest',{attrs:{"hidden":_vm.screen}}),_c('main-view'),_c('Box'),_c('HandShake',{attrs:{"touch":_vm.flag}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }